module.exports = __webpack_public_path__ + "static/media/studi1.802ab6ca.png";